<div class="card-container" #container>
  <!-- Cabeçalho do Cartão -->
  <div class="card-header-wrapper">
    <h3 class="card-title"> {{ customMsgService.translate('pagamentos') }} </h3>
    <span></span>
  </div>

  <!-- Componente do Cartão -->
  <div class="card-component">

    <kendo-grid [kendoGridBinding]="gridView" kendoGridSelectBy="id" [selectedKeys]="mySelection" [pageSize]="50"
      [pageable]="true" [sortable]="true" [groupable]="true" [filterable]="true" [reorderable]="true" [resizable]="true"
      [height]="690" [columnMenu]="{ filter: true }" (filterChange)="filterChange($event)">

      <!-- Template da Barra de Ferramentas -->
      <ng-template kendoGridToolbarTemplate>
        <!-- Caixa de Texto de Pesquisa -->
        <kendo-textbox [placeholder]="customMsgService.translate('gridSearch')" kendoTextBox style="width: 230px;"
          (valueChange)="onFilter($event)">
        </kendo-textbox>

        <!-- Formulário de Filtro de Data e Hora (Data Inicial) -->
        <form class="k-form k-form-horizontal"
          style="max-width: 200px;width: 200px; display: flex; justify-content: space-between;" [formGroup]="formGroup">
          <kendo-formfield orientation="horizontal">
            <kendo-label class="k-label" [for]="dataDe" [text]="customMsgService.translate('de')">
            </kendo-label>
            <kendo-datetimepicker formControlName="dataDe" #dataDe></kendo-datetimepicker>
          </kendo-formfield>
        </form>

        <!-- Formulário de Filtro de Data e Hora (Data Final) -->
        <form class="k-form k-form-horizontal"
          style="max-width: 350px;width: 350px; display: flex; justify-content: space-between;" [formGroup]="formGroup">
          <kendo-formfield orientation="horizontal">
            <kendo-label class="k-label" [for]="dataAte" [text]="customMsgService.translate('ate')">
            </kendo-label>
            <kendo-datetimepicker formControlName="dataAte" #dataAte></kendo-datetimepicker>
          </kendo-formfield>
          <button kendoButton (click)="pesquisar()" themeColor="primary">
            {{customMsgService.translate('filtrarEntreDatas')}}
          </button>
        </form>


        <!-- Espaçador -->
        <kendo-grid-spacer></kendo-grid-spacer>

        <!-- Botões de Exportação -->
        <button kendoGridExcelCommand type="button" [title]="customMsgService.translate('btnExportarExcel')"
          icon="file-excel" themeColor="warning">
        </button>
        <button kendoGridPDFCommand icon="file-pdf" [title]="customMsgService.translate('btnExportarPDF')"
          themeColor="warning">
        </button>
      </ng-template>

      <!-- Colunas da Grid -->
      <!-- Data do Pagamento -->
      <kendo-grid-column field="dataCriacao" [title]="customMsgService.translate('movDataHora')" [width]="45">>
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="customer-name"> {{ dataItem.dataCriacao | date:"yyyy-MM-dd HH:mm:ss" }} </div>
        </ng-template>
      </kendo-grid-column>

      <!-- Estado do Pagamento -->
      <!-- <kendo-grid-column field="descricaoEstado" [title]="customMsgService.translate('estadoPagamento')" class="auto-width">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span kendoTooltip title="{{customMsgService.translate('datahoraAtualizacao')}}: {{dataItem.dataAtualizacao | date:'yyyy-MM-dd HH:mm:ss'}}">    
            <div class="customer-name"> {{ dataItem.descricaoEstado }} </div>
          </span>
        </ng-template>
      </kendo-grid-column> -->

      <!-- Método de Pagamento -->
      <!-- <kendo-grid-column field="descricaoMetodoPagamento" [title]="customMsgService.translate('metodoPagamento')" class="auto-width">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="customer-name"> {{ dataItem.descricaoMetodoPagamento }} </div>
        </ng-template>
      </kendo-grid-column> -->

      <!-- Montante -->
      <kendo-grid-column field="montante" [title]="customMsgService.translate('montante')" [width]="30">>
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="customer-name"> {{ dataItem.montante | number:'1.2-2' }}€ </div>
        </ng-template>
      </kendo-grid-column>

      <!-- Estado da Fatura -->
      <kendo-grid-column field="fatura.descricaoEstado" [title]="customMsgService.translate('estadofatura')"
        [width]="35">>
        <ng-template kendoGridCellTemplate let-dataItem>
          <span kendoTooltip
            title="{{customMsgService.translate('datahoraAtualizacao')}}: {{ dataItem.fatura.dataAtualizacao | date:'yyyy-MM-dd HH:mm:ss'}}">
            <div class="customer-name"> {{ dataItem.fatura.descricaoEstado }} </div>
          </span>
        </ng-template>
      </kendo-grid-column>

      <!-- Identificação do Documento -->
      <kendo-grid-column field="fatura.identificacaodocumento"
        [title]="customMsgService.translate('identificacaodocumento')" [width]="40">>
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="customer-name"> {{ dataItem.fatura.identificacaodocumento }} </div>
        </ng-template>
      </kendo-grid-column>

      <!-- ID do Documento -->
      <kendo-grid-column field="fatura.iddoc" [title]="customMsgService.translate('iddoc')" [width]="35">>
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="customer-name"> {{ dataItem.fatura.iddoc }} </div>
        </ng-template>
      </kendo-grid-column>

      <!-- ID do Pagamento -->
      <kendo-grid-column field="fatura.idpagamento" [title]="customMsgService.translate('idpagamento')" [width]="35">>
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="customer-name"> {{ dataItem.fatura.idpagamento }} </div>
        </ng-template>
      </kendo-grid-column>

      <!-- Identidade -->
      <kendo-grid-column field="fatura.identidade" [title]="customMsgService.translate('identidade')" [width]="35">>
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="customer-name"> {{ dataItem.fatura.identidade }} </div>
        </ng-template>
      </kendo-grid-column>

      <!-- Fatura com Número de Contribuinte -->
      <!--       <kendo-grid-column field="fatura.numeroContribuinte"
        [title]="customMsgService.translate('faturaNumeroContribuinte')" [width]="40">>
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="customer-name"> {{ dataItem.fatura.numeroContribuinte}} </div>
        </ng-template>
      </kendo-grid-column> -->

      <!-- Armario -->
      <kendo-grid-column field="nomeArmario" [title]="customMsgService.translate('armario')" [width]="35">>
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="customer-name"> {{ dataItem.nomeArmario }} </div>
        </ng-template>
      </kendo-grid-column>

      <!-- Configuração de Exportação para PDF -->
      <kendo-grid-pdf fileName="{{customMsgService.translate('pagamentos')}}.pdf" [repeatHeaders]="true"
        [allPages]="true" paperSize="A4" [landscape]="true" [scale]="0.6">
        <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
        <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
          <div class="page-template">
            <div class="header">
              <div style="float: left">
                {{ customMsgService.translate('pagamentos') }}
              </div>
            </div>
            <div class="footer">{{ customMsgService.translate('pagina') }} {{ pageNum }} {{
              customMsgService.translate('de_') }} {{ totalPages }}</div>
          </div>
        </ng-template>

        <!-- Colunas do PDF -->
        <kendo-grid-column field="dataCriacao" filter="date"
          [title]="customMsgService.translate('dataHoraCriacaoPagamento')">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="customer-name"> {{ dataItem.dataCriacao | date:"yyyy-MM-dd HH:mm:ss" }} </div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="montante" [title]="customMsgService.translate('montante')"></kendo-grid-column>

        <kendo-grid-column field="fatura.descricaoEstado"
          [title]="customMsgService.translate('estadofatura')"></kendo-grid-column>

        <kendo-grid-column field="fatura.identificacaodocumento"
          [title]="customMsgService.translate('identificacaodocumento')"></kendo-grid-column>

        <kendo-grid-column field="fatura.iddoc" [title]="customMsgService.translate('iddoc')"></kendo-grid-column>

        <kendo-grid-column field="fatura.idpagamento" [title]="customMsgService.translate('idpagamento')">
        </kendo-grid-column>

        <kendo-grid-column field="fatura.identidade" [title]="customMsgService.translate('identidade')">
        </kendo-grid-column>

        <!--         <kendo-grid-column field="fatura.numeroContribuinte"
          [title]="customMsgService.translate('faturaNumeroContribuinte')">
        </kendo-grid-column> -->

        <kendo-grid-column field="nomeArmario" [title]="customMsgService.translate('armario')">
        </kendo-grid-column>
      </kendo-grid-pdf>

      <!-- Configuração de Exportação para Excel -->
      <kendo-grid-excel [fetchData]="allData" fileName="{{customMsgService.translate('pagamentos')}}.xlsx">

        <!-- Colunas do Excel -->
        <kendo-excelexport-column field="dataCriacao" [title]="customMsgService.translate('dataHoraCriacaoPagamento')">
        </kendo-excelexport-column>

        <kendo-excelexport-column field="descricaoEstado"
          [title]="customMsgService.translate('estadoPagamento')"></kendo-excelexport-column>

        <kendo-excelexport-column field="dataAtualizacao"
          [title]="customMsgService.translate('datahoraAtualizacao') + ' ' + customMsgService.translate('pagamento')"></kendo-excelexport-column>

        <kendo-excelexport-column field="descricaoMetodoPagamento"
          [title]="customMsgService.translate('metodoPagamento')"></kendo-excelexport-column>

        <kendo-excelexport-column field="montante"
          [title]="customMsgService.translate('montante')"></kendo-excelexport-column>

        <kendo-excelexport-column field="faturaDataCriacao"
          [title]="customMsgService.translate('dataHoraCriacaoDocumento')"></kendo-excelexport-column>

        <kendo-excelexport-column field="fatura.descricaoEstado"
          [title]="customMsgService.translate('estadofatura')"></kendo-excelexport-column>

        <kendo-excelexport-column field="faturaDataAtualizacao"
          [title]="customMsgService.translate('datahoraAtualizacao') + ' ' +  customMsgService.translate('documento')"></kendo-excelexport-column>

        <kendo-excelexport-column field="fatura.identificacaodocumento"
          [title]="customMsgService.translate('identificacaodocumento')"></kendo-excelexport-column>

        <kendo-excelexport-column field="fatura.iddoc"
          [title]="customMsgService.translate('iddoc')"></kendo-excelexport-column>

        <kendo-excelexport-column field="fatura.idpagamento"
          [title]="customMsgService.translate('idpagamento')"></kendo-excelexport-column>

        <kendo-excelexport-column field="fatura.identidade"
          [title]="customMsgService.translate('identidade')"></kendo-excelexport-column>

        <kendo-excelexport-column field="fatura.numeroContribuinte"
          [title]="customMsgService.translate('faturaNumeroContribuinte')"></kendo-excelexport-column>

        <kendo-excelexport-column field="reservaUID"
          [title]="'ID ' + customMsgService.translate('reserva')"></kendo-excelexport-column>

        <kendo-excelexport-column field="nomeArmario"
          [title]="customMsgService.translate('armario')"></kendo-excelexport-column>

      </kendo-grid-excel>

    </kendo-grid>
  </div>
</div>
<!-- Contêiner de Diálogo -->
<div kendoDialogContainer></div>